export function computeCoverDateDisplay({ mode, year, dateFrom, dateTo } = {}) {
  if (mode === "none") return "";
  if (mode === "range") {
    const a = (dateFrom || "").trim();
    const b = (dateTo || "").trim();
    if (a && b) return `${a} – ${b}`;
    return a || b;
  }
  return (year || "").trim();
}